import { TabsContent } from "@radix-ui/react-tabs";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

function AssignessTabs() {
  return (
    <TabsContent value="assignees">
      <Card className="mt-5 bg-cblack5">
        <CardContent className="pt-6 px-4 md:px-10">
          <div className="flex items-center justify-between">
            <p>Assigned By</p>
            <p>Richard Patric</p>
          </div>
          <Separator className="my-6" />
          <div className="flex items-center justify-between">
            <p>Assigned To</p>
            <Select>
              <SelectTrigger className="w-[180px] border-0 bg-transparent focus:ring-0">
                <SelectValue placeholder="Kutub Costa" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Kutub Costa</SelectLabel>
                  <SelectItem value="apple">Kutub Costa</SelectItem>
                  <SelectItem value="banana">Kutub Costa</SelectItem>
                  <SelectItem value="blueberry">Kutub Costa</SelectItem>
                  <SelectItem value="grapes">Kutub Costa</SelectItem>
                  <SelectItem value="pineapple">Kutub Costa</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
}

export default AssignessTabs;
